import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
// import bgimage from '../../../images/default_staff.png';
import bgimage from "../../../images/staff/admin.png";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from "sweetalert2";

const Edit = ({ show, onClose, user, setUser, token: propToken }) => {
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  const [showPassword, setShowPassword] = useState(false);
  const [file, setFile] = useState(null);
  const imageInputRef = useRef(null);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const token = propToken || localStorage.getItem('token');

  useEffect(() => {
    if (user && show) {
      setName(user.name || '');
      setEmail(user.email || '');
      setMobileNumber(user.mobile_number || '');
      setPassword('');
      setFile(null);
      if (imageInputRef.current) imageInputRef.current.value = '';
    }
  }, [user, show]);

  const [mail_data, setmailData] = useState([]);
  const [name_data, setuserdata] = useState([]);
  const [mobile_data, setMobData] = useState([]);

  useEffect(() => {
    axios.get(`${baseURL}/dropdown/get_validation_data`)
      .then(response => {
        const data = response.data;

        const emails = data
          .filter((item) => item.id != user_id && item.email)
          .map((item) => item.email);

        const usernames = data
          .filter((item) => item.id != user_id && item.name)
          .map((item) => item.name.toLowerCase());

        const mobile = data
          .filter((item) => item.id != user_id && item.mobile_number)
          .map((item) => item.mobile_number.toString());

        setmailData(emails);
        setuserdata(usernames);
        setMobData(mobile);
      })
      .catch(error => {
        console.log("Error fetching manage staff data", error);
      });
  }, []);

  const fileHandler = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const maxSizeKB = 50;
      const fileError = {};

      if (!allowedTypes.includes(selectedFile.type)) {
        fileError.file = "Only JPG, JPEG, and PNG files are allowed."
        e.target.value = null;
        setErrors(fileError);
        return;
      }

      if (selectedFile.size / 1024 > maxSizeKB) {
        fileError.file = "File size must be less than 50 KB."
        e.target.value = null;
        setErrors(fileError);
        return;
      }
      setErrors({});

      setFile(selectedFile);
    }

  };

  const RemoveImage = () => {
    setFile(null);
    if (imageInputRef.current) imageInputRef.current.value = '';
  };

  const validate = () => {
    const newErrors = {};
    const regex = /^[A-Za-z\s]+$/;

    console.log("name: ", name, name_data);
    console.log("mobile: ", mobileNumber, mobile_data);
    console.log("email: ", email, mail_data);

    if (!name.trim()) {
      newErrors.name = "This Field is Required.";
    } else if (!regex.test(name)) {
      newErrors.name = "Not a Valid Name";
    } else if (name_data.includes(name.trim().toLowerCase())) {
      newErrors.name = "This Name Already Exists";
    }

    if (!mobileNumber) {
      newErrors.mob = "This Field is Required.";
    } else if (mobileNumber.length < 10) {
      newErrors.mob = "Enter a Valid Number.";
    } else if (mobile_data.includes(mobileNumber)) {
      newErrors.mob = "This Mobile Already Exists";
    }

    if (!email) {
      newErrors.email = "This Field is Required.";
    } else if (email && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
      newErrors.email = "Invalid Email.";
    } else if (mail_data.includes(email.trim().toLowerCase())) {
      newErrors.email = "This Email Already Exists";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const data = new FormData();
      data.append("name", name);
      data.append("email", email);
      data.append("mobile_number", mobileNumber);
      if (file) data.append("img", file);

      const response = await axios.post(`${baseURL}/update-profile`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data?.data) {
        setUser(response.data.data);
      }

      // toast.success("Profile Updated Successfully!");
      onClose();
      swal.fire({
        title: "Success!",
        text: "Profile Updated Successfully!",
        icon: "success",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          // Reload the page after user clicks OK
          window.location.reload();
        }
      });

    } catch (err) {
      console.log("Profile update failed:", err);
      // toast.error("Profile Updation Failed");
      swal.fire({
        title: "Error!",
        text: "Profile Updation Failed",
        icon: "error",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          // Optional: reload page or handle differently
          window.location.reload();
        }
      });
    }
  };

  return (
    <Modal show={show} size="md" onHide={onClose} centered>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
            <h3 className="modal-title text-white">Update Profile</h3>
            <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
              <span className="text-white">×</span>
            </Button>
          </div>
          <div className="modal-body">

            <div className="row">
              <div className="col-lg-12 mb-4">
                <label className="text-black font-w500 fs-7">Name <span className="required">*</span></label>
                <input placeholder='Enter Name' type="text" className="form-control" value={name} maxLength={254} onChange={(e) => setName(e.target.value)} />
                {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
              </div>
              <div className="col-lg-12 mb-4">
                <label className="text-black font-w500 fs-7">Email <span className="required">*</span></label>
                <input placeholder='Enter Email' type="email" className="form-control" value={email} maxLength={300} onChange={(e) => setEmail(e.target.value)} />
                {errors.email && <div className="text-danger fs-8 mt-1">{errors.email}</div>}
              </div>
              <div className="col-lg-12 mb-4">
                <label className="text-black font-w500 fs-7">Mobile Number <span className="required">*</span></label>
                <input placeholder='Enter Mobile Number' type="text" className="form-control" value={mobileNumber} maxLength={10}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                    setMobileNumber(onlyNums);
                  }}
                />
                {errors.mob && <div className="text-danger fs-8 mt-1">{errors.mob}</div>}
              </div>
              <div className="col-lg-12 mb-4">
                <label className="text-black font-w500 fs-7 d-block">Profile Image</label>
                <span className='fs-8 text-gray-800'>Max Size: </span>
                <span className='fs-8 text-danger'>50 KB</span>
                <span className='fs-8 text-gray-800 ms-2'>Format: </span>
                <span className='fs-8 text-danger'>.png, .jpg</span>
                <div className="avatar-upload d-flex align-items-center">
                  <div className="change position-relative px-0">
                    <div className="avatar-preview h-100px w-100px border" style={{ borderRadius: '10px' }}>
                      <img
                        src={
                          file
                            ? URL.createObjectURL(file)
                            : user?.img_url || bgimage
                        }
                        alt="Profile"
                        className="p-1 h-100px w-100px"
                      />
                    </div>
                    <div className="change-btn">
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg"
                        style={{ display: 'none' }}
                        ref={imageInputRef}
                        onChange={fileHandler}
                      />
                      <div className="mt-2 d-flex justify-content-center gap-3">
                        <Button variant="success" className="btn-xs mb-2" onClick={() => imageInputRef.current.click()} type="button">
                          <i className="fa fa-upload color-success fs-4" />
                        </Button>
                        <Button variant="danger" className="btn-xs mb-2" onClick={RemoveImage} type="button">
                          <i className="fa fa-close color-danger fs-4" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                {errors.file && <div className="text-danger fs-8 mt-1">{errors.file}</div>}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
              <Button variant="primary" className="btn btn-sm btn-primary" type="submit">Update Profile <i className="fas fa-angle-double-right ms-2"></i></Button>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default Edit;
